/**
 * Canonical hostname must be a non-empty string (after trim).
 * FormData values may be File | string | null depending on the control.
 */
export function hasRequiredCanonicalHostname(
  value: FormDataEntryValue | string | null | undefined
): boolean {
  return typeof value === "string" && value.trim().length > 0;
}
